import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function Community(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, "data-tidal": "TidalIllustration", "data-tidal-illustration": "Community", sx, viewBox, children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M8.25 38.25c2.0711 0 3.75-1.6789 3.75-3.75s-1.6789-3.75-3.75-3.75c-2.07107 0-3.75 1.6789-3.75 3.75s1.67893 3.75 3.75 3.75Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M8.25 38.25c-1.5913 0-3.11742.6321-4.24264 1.7574C2.88214 41.1326 2.25 42.6587 2.25 44.25h12c0-1.5913-.6321-3.1174-1.7574-4.2426C11.3674 38.8821 9.8413 38.25 8.25 38.25Zm31.5 0c2.0711 0 3.75-1.6789 3.75-3.75s-1.6789-3.75-3.75-3.75S36 32.4289 36 34.5s1.6789 3.75 3.75 3.75Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M39.75 38.25c-1.5913 0-3.1174.6321-4.2426 1.7574-1.1253 1.1252-1.7574 2.6513-1.7574 4.2426h12c0-1.5913-.6321-3.1174-1.7574-4.2426-1.1252-1.1253-2.6513-1.7574-4.2426-1.7574Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M6 27.9285c-.19891 0-.38968-.079-.53033-.2197-.14065-.1406-.21967-.3314-.21967-.5303.00425-3.6822 1.09258-7.2816 3.12922-10.3492 2.03668-3.0676 4.93148-5.4677 8.32328-6.90079.184-.07758.3913-.07889.5762-.00364.185.07523.3325.22093.41.40493.0776.1839.0789.3912.0037.5762-.0753.1849-.2209.3324-.4049.41-3.1195 1.3178-5.7822 3.5246-7.65605 6.3454-1.87384 2.8207-2.87597 6.1307-2.88145 9.5171 0 .1989-.07902.3897-.21967.5303-.14065.1407-.33142.2197-.53033.2197Zm18 18c-2.6727.0063-5.3154-.5642-7.7475-1.6725-.1348-.1038-.2303-.2504-.2708-.4157-.0405-.1652-.0236-.3394.0479-.4938.0715-.1543.1934-.2798.3457-.3558.1523-.076.3258-.0979.4922-.0622 2.2396 1.0099 4.6683 1.5322 7.125 1.5322 2.4567 0 4.8854-.5223 7.125-1.5322.1801-.0816.3852-.0888.5706-.02.1855.0688.3362.2081.4194.3875.0414.0901.0645.1874.068.2864.0035.099-.0127.1978-.0475.2905-.0349.0928-.0878.1777-.1557.2499-.0679.0722-.1494.1302-.2398.1707-2.4305 1.0931-5.0676 1.6507-7.7325 1.635Zm18-18c-.1989 0-.3897-.079-.5303-.2197-.1407-.1406-.2197-.3314-.2197-.5303.0081-3.4255-1.007-6.7754-2.9152-9.6202-1.9081-2.8449-4.6224-5.0551-7.7948-6.3473-.097-.0326-.1864-.0847-.2625-.1531-.0762-.0684-.1375-.1516-.1803-.2446-.0427-.0931-.066-.1938-.0683-.2962-.0024-.1023.0163-.204.0547-.2989.0385-.0948.096-.1808.1689-.25264.0729-.07181.1598-.12794.2553-.16491.0954-.03698.1974-.05403.2997-.0501.1023.00393.2027.02876.295.07296 3.4501 1.40239 6.4024 3.80389 8.4778 6.89629 2.0754 3.0924 3.1792 6.7345 3.1697 10.4587 0 .1989-.079.3897-.2197.5303-.1406.1407-.3314.2197-.5303.2197Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M31 27c0-.7956-.3161-1.5587-.8787-2.1213C29.5587 24.3161 28.7956 24 28 24h-5.25l-3-3v3H19c-.7956 0-1.5587.3161-2.1213.8787C16.3161 25.4413 16 26.2044 16 27v6c0 .7956.3161 1.5587.8787 2.1213C17.4413 35.6839 18.2044 36 19 36v3l2.895-3H28c.7956 0 1.5587-.3161 2.1213-.8787C30.6839 34.5587 31 33.7956 31 33v-3h3.75L31 27Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M26.5 29.25h-6c-.1989 0-.3897-.079-.5303-.2197-.1407-.1406-.2197-.3314-.2197-.5303 0-.1989.079-.3897.2197-.5303.1406-.1407.3314-.2197.5303-.2197h6c.1989 0 .3897.079.5303.2197.1407.1406.2197.3314.2197.5303 0 .1989-.079.3897-.2197.5303-.1406.1407-.3314.2197-.5303.2197Zm0 3h-6c-.1989 0-.3897-.079-.5303-.2197-.1407-.1406-.2197-.3314-.2197-.5303 0-.1989.079-.3897.2197-.5303.1406-.1407.3314-.2197.5303-.2197h6c.1989 0 .3897.079.5303.2197.1407.1406.2197.3314.2197.5303 0 .1989-.079.3897-.2197.5303-.1406.1407-.3314.2197-.5303.2197Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M24 10.5c2.0711 0 3.75-1.67893 3.75-3.75C27.75 4.67893 26.0711 3 24 3s-3.75 1.67893-3.75 3.75c0 2.07107 1.6789 3.75 3.75 3.75Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M24 10.5c-1.5913 0-3.1174.6321-4.2426 1.7574C18.6321 13.3826 18 14.9087 18 16.5h12c0-1.5913-.6321-3.1174-1.7574-4.2426C27.1174 11.1321 25.5913 10.5 24 10.5Z",
        fill: theme.vars.palette.primary.light
      }
    )
  ] });
}
Community.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "Community"
};
validateTidalLicense();
export {
  Community
};
//# sourceMappingURL=Community.js.map
